var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
Throttly = require('throttly');
require('../../src/js/vendor/slick.js');
//require('slick-carousel');

/**
 * Initializes the Home hero - year roundmodule.
 * @constructor
 * @param {Object} el - The Home hero - year round element.
 */
function HomeHeroYR(el) {
  this.el = el;
  this.$el = $(el);

  //Slideshow
  $('.js-hero-slideshow').slick({
		dots: true,
		infinite: true,
		speed: 800,
		autoplay: true,
		autoplaySpeed: 6000,
		fade: true,
		arrows: false
	});
}

module.exports = HomeHeroYR;
